import { NavLink } from 'react-router-dom';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { Explore } from '@mui/icons-material';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import Person from '@mui/icons-material/Person';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import useSideBarNavStyles from './useSideBarNavStyles';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { setSidebarOpen } from '../../../redux/slices/layoutSlice';
import { currentUserSelector, logout } from '../../../redux/slices/userSlice';
import { setSearchString } from '../../../redux/slices/questionsSlice';

/**
 * The SideBarNav component has two menu items: "Questions" and "Tags".
 * It highlights the currently selected item based on the active page and
 * triggers corresponding functions when the menu items are clicked.
 */
const SideBarNav = () => {
  const { classes } = useSideBarNavStyles();
  const currentUser = useAppSelector(currentUserSelector);
  const dispatch = useAppDispatch();

  const handleSidebarClick = () => {
    dispatch(setSidebarOpen(false));
    dispatch(setSearchString(''));
  };

  return (
    <div id='sideBarNav' className={classes.sideBarNav}>
      <div className={classes.sideBarNavOptions}>
        <NavLink
          to='/home'
          id='menu_explore'
          className={({ isActive }) =>
            `${classes.menuButton} ${isActive ? classes.menuSelected : ''}`
          }
          onClick={handleSidebarClick}>
          <Explore />
          Explore
        </NavLink>
        <NavLink
          to='/questions'
          id='menu_questions'
          className={({ isActive }) =>
            `${classes.menuButton} ${isActive ? classes.menuSelected : ''}`
          }
          onClick={handleSidebarClick}>
          <QuestionAnswerIcon />
          Questions
        </NavLink>
        <NavLink
          to='/tags'
          id='menu_tag'
          className={({ isActive }) =>
            `${classes.menuButton} ${isActive ? classes.menuSelected : ''}`
          }
          onClick={handleSidebarClick}>
          <LocalOfferIcon />
          Tags
        </NavLink>
        <NavLink
          to='/notifications'
          id='menu_notifications'
          className={({ isActive }) =>
            `${classes.menuButton} ${isActive ? classes.menuSelected : ''}`
          }
          onClick={handleSidebarClick}>
          <NotificationsIcon />
          Notifications
        </NavLink>
        <NavLink
          to='/search-users'
          id='menu_users'
          className={({ isActive }) =>
            `${classes.menuButton} ${isActive ? classes.menuSelected : ''}`
          }
          onClick={handleSidebarClick}>
          <PersonSearchIcon />
          Search Users
        </NavLink>
        <NavLink
          to={`/profile/${currentUser?.username || 'user-not-found'}`}
          id='menu_profile'
          className={({ isActive }) =>
            `${classes.menuButton} ${isActive ? classes.menuSelected : ''}`
          }
          onClick={() => {
            handleSidebarClick();
          }}>
          <Person />
          My Profile
        </NavLink>
      </div>
      <NavLink
        to='/'
        id='menu_login'
        className={`${classes.menuButton} ${classes.logoutButton}`}
        onClick={() => {
          handleSidebarClick();
          dispatch(logout());
        }}>
        <ExitToAppIcon />
        Log Out
      </NavLink>
    </div>
  );
};

export default SideBarNav;
